import BuildingStatsDashboard from '../components/BuildingStatsDashboard';

const StatsPage: React.FC = () => {
  return (
    <div className="page-full">
      <div className="mb-5">
        <h1 className="page-title">통계 대시보드</h1>
        <p className="page-subtitle">동 유형 분류 및 접근성 통계</p>
      </div>
      <BuildingStatsDashboard />
    </div>
  );
};

export default StatsPage;
